import { render, staticRenderFns } from "./recording-mode.vue?vue&type=template&id=3dd213ce"
import script from "./recording-mode.vue?vue&type=script&lang=js"
export * from "./recording-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports